import script from "./usuariosLista.vue?vue&type=script&setup=true&lang=js"
export * from "./usuariosLista.vue?vue&type=script&setup=true&lang=js"

import "./usuariosLista.vue?vue&type=style&index=0&id=181d896d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181d896d"]])

export default __exports__